import type { SVGProps } from "react";
const SvgIconEye = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1024 1024" {...props}>
    <circle cx={512} cy={512} r={512} fill="currentColor" />
    <path d="M871.02 537.01c-9.5 0-18.57-5.44-22.77-14.64C788.37 390.93 656.38 306 512 306s-276.37 84.93-336.25 216.37c-5.72 12.56-20.55 18.11-33.12 12.38-12.56-5.72-18.11-20.55-12.38-33.12 32.91-72.23 85.47-133.48 152-177.14 68.29-44.81 147.74-68.5 229.75-68.5s161.46 23.69 229.75 68.5c66.53 43.66 119.09 104.91 152 177.14 5.72 12.56.18 27.39-12.38 33.12a24.9 24.9 0 0 1-10.35 2.26" />
    <circle cx={512} cy={512} r={144} />
  </svg>
);
export default SvgIconEye;
